// extracted by mini-css-extract-plugin
module.exports = {"center":"styles-module--center--1YSFq","temp":"styles-module--temp--1WfYo"};